import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Applies a promo code to an office on its behalf:
 * `POST /v1/admin/offices/:officeId/applied-codes` (campaign-service PR #159,
 * GOTU-8097). Needs the admin's `campaign:manage_promo_codes` claim.
 *
 * Runs the office route's own refusal ladder, so a refusal rejects with a
 * `{ reason, message }` body: 404 `invalid_code`, 410 `promotion_ended`,
 * 403 `not_eligible` (or `not_authorized` for a missing claim). Unlike the
 * office route, applying a code the office already holds is refused too, with
 * 409 `already_applied`, so the admin knows nothing changed (campaign-service
 * #154, GOTU-8101).
 */
export const applyOfficePromoCode = async (officeId, code) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post(
    `/campaign-service/v1/admin/offices/${officeId}/applied-codes`,
    { code },
    { headers },
  );

  return response.data;
};
